import { Component, ElementRef, forwardRef, Inject, NgZone, PLATFORM_ID, TransferState } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

import {
  DxTemplateHost,
  DxTextAreaComponent,
  IterableDifferHelper,
  NestedOptionHost,
  WatcherHelper,
} from 'devextreme-angular';
import { AbcTooltipDirective } from '../abc-tooltip.directive';
import { AbcCoreComponentService } from '../abcCoreComponent.service';

@Component({
  selector: 'abc-text-area',
  standalone: true,
  providers: [
    DxTemplateHost,
    WatcherHelper,
    IterableDifferHelper,
    NestedOptionHost,
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: forwardRef(() => _AbcTextAreaComponent),
    },
  ],
  template: '',
})
export class _AbcTextAreaComponent extends DxTextAreaComponent {
  constructor(
    elementRef: ElementRef,
    ngZone: NgZone,
    templateHost: DxTemplateHost,
    _watcherHelp: WatcherHelper,
    _idh: IterableDifferHelper,
    optionHost: NestedOptionHost,
    transferState: TransferState,
    @Inject(PLATFORM_ID) platformId: any,
    private abcCoreComponentService: AbcCoreComponentService,
  ) {
    super(elementRef, ngZone, templateHost, _watcherHelp, _idh, optionHost, transferState, platformId);
    this.labelMode = this.labelMode ?? this.abcCoreComponentService.labelMode;
    this.stylingMode = this.stylingMode ? this.stylingMode : this.abcCoreComponentService.stylingMode;
    const tooltTip = new AbcTooltipDirective(this.element);
    tooltTip.elementClassName = '.dx-texteditor-input';
  }
}
